import Picture from '@/components/picture'
import { STRINGS } from '@/constants/contactUs'

const contactUsAssetDir = '/assets/images/contact-us'

const ContactUsBanner = () => {
  return (
    <section className="border border-[#ECECEC] rounded flex md:flex-row flex-col overflow-hidden">
      <article className="bg-[#6FBC1D] md:w-1/2 p-[30px] w-full">
        <Picture
          image={`${contactUsAssetDir}/phone-call`}
          imageAlt={`${STRINGS.CONTACT_US_AT} ${STRINGS.CONTACT_NUMBER}`}
          aria-hidden="true"
          height={97}
          width={84}
        />
        <p className="mt-6 mb-2.5 sm:text-2xl text-xl leading-[1.3]">
          {STRINGS.FREE_FARM_ADVISORY}
        </p>
        <a
          href={`tel:${STRINGS.CONTACT_NUMBER.split(' ').join('')}`}
          className="sm:text-6xl text-3xl font-natosans-medium mt-5 mb-2.5 leading-none block"
        >
          {STRINGS.CONTACT_NUMBER}
        </a>
      </article>
      <article className="md:w-1/2 p-[30px] w-full">
        <Picture
          image={`${contactUsAssetDir}/email`}
          imageAlt={`${STRINGS.CONTACT_US_AT} ${STRINGS.CONTACT_EMAIL_ID}`}
          aria-hidden="true"
          height={84}
          width={97}
        />
        <p className="mt-6 mb-2.5 sm:text-2xl text-xl leading-[1.3]">
          {STRINGS.FEEL_FREE_TO_CONTACT_US}
        </p>
        <a
          href={`mailto:${STRINGS.CONTACT_EMAIL_ID}`}
          className="sm:text-[40px] text-2xl leading-[1.43] font-natosans-medium mt-5 mb-2.5 leading-none block break-words"
        >
          {STRINGS.CONTACT_EMAIL_ID}
        </a>
      </article>
    </section>
  )
}

export default ContactUsBanner
